import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import Avatar from "components/common/Avatar";
import { useDispatch, useSelector } from "react-redux";
import { setUserData, setUserPermission } from "../../../Redux/userSlice";

const ProfileDropdown = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const loggedUserData = useSelector(state => state.DreamsAdminUser.userData);
  const handleLogout = () => {
    dispatch(setUserData({}))
    dispatch(setUserPermission({}))
    localStorage.removeItem('UserAuthToken');
    localStorage.removeItem('UserAuthTokenExpiry');
    navigate('/logout')
  }
  return (
    <Dropdown navbar={true} as="li">
      <Dropdown.Toggle
        bsPrefix="toggle"
        as={Link}
        to="#!"
        className="pe-0 ps-2 nav-link"
      >
        <Avatar name={loggedUserData?.name} />
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropdown-caret dropdown-menu-card  dropdown-menu-end">
        <div className="bg-white rounded-2 py-2 dark__bg-1000">
          <Dropdown.Item as={Link} to="/">
            Profile Settings
          </Dropdown.Item>
          <Dropdown.Item as={Link} to="/reset-password">
            Reset Password
          </Dropdown.Item>
          <Dropdown.Item onClick={() => handleLogout()}>
            Logout
          </Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;
